//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[],[[["filename"],"GetPreview",{R_:{preview:''}},1,0],[["filename","numAttributes","attributeTitles","attributeValues"],"GetAttributes",{},1,0],[["fileName","storagePath","numPreviews","folders","previews"],"GetPreviewsFromStoragePath",{},2,0]],[]];
SPLM.QuickAccessFolders = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.QuickAccessFolders";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;